module.exports = __webpack_public_path__ + "img/IMG_2072.19e1d725.jpg";